export const sportReducer = (
	state = {
		list: undefined,
		count: 0,
		sportsData: [],
		sportsDetails: undefined,
		detail: undefined,
	},
	action
) => {
	switch (action.type) {
		case "SPORTS_LIST_SUCCESS":
		case "SPORTS_SEARCH_SUCCESS":
			return {
				...state,
				list: action.payload.list,
				count: action.payload.count,
				sportsData: action.payload.sportsData,
			};
		case "FETCH_SPORTS_DETAILS":
			return {
				...state,
				sportsDetails: action.payload,
			};
		case "CLEAR_SPORTS_DETAILS":
			return {
				...state,
				sportsDetails: undefined,
			};
		case "SPORTS_TOGGLE_SUCCESS":
			return {
				...state,
				sportsDetails: { ...state?.sportsDetails, isActive: !state?.sportsDetails?.isActive },
			};
		case "SPORTS_SEARCH_CLEAR":
			return {
				...state,
				list: undefined,
				count: 0,
			};
		default:
			return state;
	}
};
